export class SkillTemplateSkill {
  public readonly id!: string;
  public readonly full_name!: string;

  public selected?: boolean;
}
